import type { ViewFilterValue } from './ViewFilter';

export interface FilteredEmptyHintProps {
  viewFilter: ViewFilterValue;
}

/**
 * The quiet line shown when the user HAS content but the active filter excludes
 * everything on this page — a blank container otherwise reads as a broken grid.
 *
 * Deliberately not an empty state: the exit is to change the filter, which is
 * still on screen right above, so a CTA would just point at itself.
 */
export function FilteredEmptyHint({ viewFilter }: FilteredEmptyHintProps) {
  return (
    <div className='flex h-40 items-center justify-center text-sm text-muted-foreground'>
      {viewFilter === 'folders'
        ? 'No folders yet - create one with the folder button.'
        : 'No lessons on this page for the current filter.'}
    </div>
  );
}
